import React from 'react'
import styled from 'styled-components'

import playBtnIcon from '@/images/icons/play-btn.svg'
import {useGlobalStrings} from '@helios/shared/providers/global-strings'
import {colors, radii} from '@helios/shared/theme'
import mq from '@helios/shared/utils/media-query'

const PlayButton = React.forwardRef<
    HTMLButtonElement,
    React.PropsWithChildren<React.ComponentProps<typeof StyledPlayButton>>
>(({'aria-label': ariaLabel, onClick, size, ...props}, ref) => {
    const globalStrings = useGlobalStrings()
    return (
        <StyledButton ref={ref} {...props} onClick={onClick}>
            <StyledPlayButton $size={size} aria-label={ariaLabel || globalStrings.playVideo} />
        </StyledButton>
    )
})

const StyledButton = styled.button`
    background: transparent;
    border: none;
`

interface PlayButtonProps {
    $size?: 'small' | 'regular'
}

export const StyledPlayButton = styled.span<PlayButtonProps>`
    display: block;
    width: 86px;
    height: 86px;
    padding: 0;
    cursor: pointer;
    background-color: ${colors.button.default.background};
    background-image: url(${playBtnIcon});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50%;
    border: none;
    border-radius: ${radii.circle};

    :hover,
    :focus,
    :active {
        background-color: ${colors.button.default.hover.background};
    }

    ${mq.min('sm')} {
        width: ${(props) => (props.$size === 'small' ? '86px' : '112px')};
        height: ${(props) => (props.$size === 'small' ? '86px' : '112px')};
    }
`

export default PlayButton
